(function () {
    const STORAGE_KEY = 'as-free-gift-popup-dismissed';

    function getDismissed() {
        try {
            return sessionStorage.getItem(STORAGE_KEY) === '1';
        } catch (error) {
            console.warn('Free gift popup: unable to access sessionStorage.', error);
            return false;
        }
    }

    function setDismissed(value) {
        try {
            if (value) {
                sessionStorage.setItem(STORAGE_KEY, '1');
            } else {
                sessionStorage.removeItem(STORAGE_KEY);
            }
        } catch (error) {
            console.warn('Free gift popup: unable to update sessionStorage.', error);
        }
    }

    class FreeGiftPopupController {
        constructor(element) {
            this.element = element;
            this.dialog = element.querySelector('[data-free-gift-dialog]');
            this.overlay = element.querySelector('[data-free-gift-overlay]');
            this.dismissTrigger = element.querySelector('[data-free-gift-dismiss]');
            this.closeButtons = element.querySelectorAll('[data-free-gift-close]');
            this.baseGiftProductIds = this.parseProductIds(element.dataset.giftProductIds || '');
            this.specialTriggerIds = this.parseProductIds(element.dataset.specialTriggerIds || '');
            this.specialGiftId = this.parseSingleId(element.dataset.specialGiftId);
            this.specialGiftCard = element.querySelector('[data-special-gift-card]');
            this.allGiftProductIds = [...this.baseGiftProductIds];
            if (this.specialGiftId) {
                this.allGiftProductIds.push(this.specialGiftId);
            }
            this.cartHasGift = false;
            this.hasSpecialTrigger = false;
            this.isOpen = false;
            this.hasShown = false;

            this.handleKeydown = this.handleKeydown.bind(this);
            this.handleCartEvent = this.handleCartEvent.bind(this);

            this.registerEvents();
            this.refreshCartState();
            this.subscribeToCartUpdates();
        }

        parseProductIds(value) {
            return value
                .split(',')
                .map((id) => parseInt(id.trim(), 10))
                .filter((id) => !Number.isNaN(id));
        }

        parseSingleId(value) {
            const parsed = parseInt(value, 10);
            return Number.isNaN(parsed) ? null : parsed;
        }

        registerEvents() {
            if (this.overlay) {
                this.overlay.addEventListener('click', () => this.hide(true));
            }
            if (this.dismissTrigger) {
                this.dismissTrigger.addEventListener('click', () => this.hide(true));
            }
            this.closeButtons.forEach((button) => {
                button.addEventListener('click', () => this.hide(true));
            });
            document.addEventListener('keydown', this.handleKeydown);
        }

        subscribeToCartUpdates() {
            if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
                console.warn('Free gift popup: pub/sub is not available.');
                return;
            }
            subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartEvent);
        }

        async handleCartEvent(event = {}) {
            await this.refreshCartState();

            if (this.cartHasGift) {
                if (this.isOpen) {
                    this.hide(false);
                }
                return;
            }

            if (event.source !== 'product-form') {
                return;
            }

            if (this.isOpen || this.hasShown || getDismissed()) {
                return;
            }

            this.show();
        }

        async refreshCartState() {
            const previousState = this.cartHasGift;
            if (!this.allGiftProductIds.length) {
                this.cartHasGift = true;
                return;
            }

            try {
                const response = await fetch('/cart.js', { credentials: 'same-origin' });
                if (!response.ok) throw new Error('Cart request failed');
                const cart = await response.json();
                const items = Array.isArray(cart.items) ? cart.items : [];
                const productIds = items.map((item) => item.product_id);
                this.hasSpecialTrigger = this.specialTriggerIds.length
                    ? productIds.some((id) => this.specialTriggerIds.includes(id))
                    : false;
                this.cartHasGift = productIds.some((id) => this.allGiftProductIds.includes(id));
            } catch (error) {
                console.warn('Free gift popup: unable to inspect cart contents.', error);
                this.cartHasGift = false;
                this.hasSpecialTrigger = false;
            }

            this.toggleSpecialGiftCard();

            if (previousState && !this.cartHasGift && !getDismissed()) {
                this.hasShown = false;
            }
        }

        toggleSpecialGiftCard() {
            if (!this.specialGiftCard) {
                return;
            }

            if (this.hasSpecialTrigger) {
                this.specialGiftCard.removeAttribute('hidden');
            } else {
                this.specialGiftCard.setAttribute('hidden', 'hidden');
            }
        }

        show() {
            if (this.cartHasGift || this.isOpen) {
                return;
            }
            this.element.classList.add('is-visible');
            this.element.setAttribute('aria-hidden', 'false');
            document.body.classList.add('free-gift-popup-open');
            if (this.dialog) {
                this.dialog.focus({ preventScroll: true });
            }
            this.isOpen = true;
            this.hasShown = true;
        }

        hide(dismiss = false) {
            if (!this.isOpen) {
                if (dismiss) setDismissed(true);
                return;
            }
            this.element.classList.remove('is-visible');
            this.element.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('free-gift-popup-open');
            this.isOpen = false;
            if (dismiss) {
                setDismissed(true);
            }
        }

        handleKeydown(event) {
            if (event.key === 'Escape' && this.isOpen) {
                event.preventDefault();
                this.hide(true);
            }
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        const popupElement = document.querySelector('[data-free-gift-popup]');
        if (!popupElement) return;
        new FreeGiftPopupController(popupElement);
    });
})();
